import { Button } from '@progress/kendo-react-buttons';
import * as React from 'react';

const CusGreenBtn = (props) => {
 
 
    const onHandleClick = React.useCallback(
        (e) => {
            props.onClick(e);
        },
        []
    )
    return (

        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div style={{textAlign:'center'}}>
                    <Button className="k-button btn btn-success" style={props.style} onClick={onHandleClick}>{props.lbtxt}</Button>
                </div>
            </div>
        </div>
    )
}

export default CusGreenBtn;